// extracted by mini-css-extract-plugin
module.exports = {"counter":"PlayerScore_counter__PGvpR","bubble":"PlayerScore_bubble__TVcl0","number":"PlayerScore_number__UW8wE","previous":"PlayerScore_previous__3NdLn"};